import axios from 'axios';
import 'regenerator-runtime/runtime';
import logger from '../common/logger';

const PLATFORM_API_URL = process?.env?.PARTNER_API_URL ?? 'https://local.gu-api.com';


const httpResponse = (res = {}) => {
  logger.info('', { res });
  return {
    headers: res.header || {},
    data: res.data || {},
    status: res.status || 0,
  };
};

const handleAxiosError = (error) => {
  logger.error('', { error });
  if (!error.response && !error.request) throw error;
  return error.response ? httpResponse(error.response) : httpResponse({ status: 500, data: { error: error.request } });
};
const PixelConfigurationHttpClient = {
  getPixelConfigurationAsync: (payload) => {
    const apiPath = '/marketing-partners/retrieve_configs/'
    return axios.post(`${PLATFORM_API_URL}${apiPath}`, { payload }).then(httpResponse, handleAxiosError);
  }
};
export default PixelConfigurationHttpClient;